import type { Resource } from '../../';
export const product_tiles_numberOfColors: Resource = {"default":"{itemCount} {itemCount, plural,\n                        one {color}\n                        other {colors}\n                      }"};
